export default __webpack_public_path__ + "static/media/SportELS_LateralDer.cf91928e.webp";